var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPotty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H4.5C3.67157 12 3 11.3284 3 10.5V10.5C3 9.67157 3.67157 9 4.5 9H15",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2H20C20.5523 2 21 2.44772 21 3V11C21 11.5523 20.5523 12 20 12H15V3C15 2.44772 15.4477 2 16 2Z",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11V11.8377C21 13.7262 19.7916 15.4028 18 16V20C18 20.5523 17.5523 21 17 21H9.28078C8.97284 21 8.68208 20.8581 8.49257 20.6154C8.30306 20.3727 8.23594 20.0562 8.31063 19.7575L9 17L8.88057 16.9701C6.59993 16.4 5 14.3508 5 12",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotty);
export default __webpack_public_path__ + "static/media/potty.265e51dac2cc95be69f2a2d5ecad3e5c.svg";
export { ForwardRef as ReactComponent };